import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import menuReducer from './slices/menuSlice';
import metaAnchorReducer from './slices/metaAnchorSlice';
import nftPageReducer from './slices/nftPageSlice';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    whitelist: ['metaAnchor'],
};

const rootReducer = combineReducers({
    menu: menuReducer,
    metaAnchor: metaAnchorReducer,
    nftPage: nftPageReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const makeStore = () => {
    return configureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }),
    });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const store = makeStore();
export const persistor = persistStore(store);
